import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-neutral-500">
        <li>
          <Link to="/" className="hover:text-indigo-800 transition-colors">
            Home
          </Link>
        </li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1">
            <ChevronRight size={13} className="text-neutral-300" />
            {item.to ? (
              <Link to={item.to} className="hover:text-indigo-800 transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-neutral-900 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
